import type { MailboxInfo } from 'owa-client-ids';
import { errorThatWillCauseAlertAndThrow } from 'owa-trace';

import { globalProfile, microsoft365SourceType, buildSourceId } from './sourceIdBuilder';

// In OWA we need the ability to map SourceIds to mailboxes, this is done by keeping an in memory map
// of these
const mailboxInfoBySourceId = new Map<string, MailboxInfo>();

export function getInMemorySourceIdForMailboxInfo(mailbox: MailboxInfo): string {
    const sourceId = buildSourceId(globalProfile, microsoft365SourceType, mailbox.userIdentity);
    mailboxInfoBySourceId.set(sourceId, mailbox);
    return sourceId;
}

export function getInMemoryMailboxInfoBySourceId(sourceId: string): MailboxInfo {
    const mailbox = mailboxInfoBySourceId.has(sourceId)
        ? mailboxInfoBySourceId.get(sourceId)
        : undefined;

    if (!mailbox) {
        // When using the in memory mailbox information the getInMemorySourceIdForMailboxInfo must be called
        // prior to calling the getInMemoryMailboxInfoBySourceId method
        const errorMessage = 'InvalidInMemorySourceId';
        errorThatWillCauseAlertAndThrow(errorMessage);
    }

    return mailbox!;
}
